import React from 'react'

const Agents = () => {
  return (
    <div style={{marginTop:"80px"}}>Agents</div>
  )
}

export default Agents